"use client";

import { CaseStudyCard } from "../common/CaseStudyCard";
import { Heading } from "@/components/ui/typography";

const caseStudies = [
  {
    title: "Australian eCommerce Brand",
    type: "Case study · eCommerce",
    image: "/tax-optimization/case-studies-1.png",
    stats: [
      { label: "Annual savings", value: "Over $85,000" },
      { label: "Country", value: "Australia" },
      { label: "Annual profit", value: "$320,000" },
    ],
  },
  {
    title: "UK SaaS Founder",
    type: "Case study · SaaS",
    image: "/tax-optimization/case-studies-2.png",
    stats: [
      { label: "Annual savings", value: "$40,000+" },
      { label: "Country", value: "UK" },
      { label: "Annual profit", value: "$320,000" },
    ],
  },
];

export default function CaseStudies({ heading = "Case Studies" }: { heading?: string } = {}) {
  return (
    <section className="bg-black py-[60px] px-4 flex justify-center">
      <div className="w-full max-w-[1200px] flex flex-col gap-[50px] items-center">

        {/* HEADING */}
        <Heading as="h2" variant="sectionCentered">
          {heading}
        </Heading>

        {/* GRID */}
        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-8">
          {caseStudies.map((item, index) => (
            <CaseStudyCard key={index} data={item} />
          ))}
        </div>
      </div>
    </section>
  );
}

/* ---------------- CARD ---------------- */
